<template>
  <OnClickOutside :do="closePopper">
  <div class="party_select flex">
    <div class="select-placeholder sm:mr-2 ">
      <slot />
    </div>
    <div ref="selector" class="selector cursor-pointer flex items-center relative text-xs font-normal" @click="dropDownToggle">
      <p>
        {{selected}}
      </p>
       <MozIcon class="ml-2 w-2 h-1 selector-handler" :class="popIsOpen ? 'deg' : ''" iconName="arrowDown" />
    </div>
    <div ref="items" v-show="popIsOpen" class="items border overflow-hidden  rounded-lg border-brand-gray-dark bg-white z-10">
      <div
        v-for="(option, idx) in selectOptions"
        :key="idx"
        @click="selectOption(idx)"
        class="party_select-item pl-4 p-2 flex items-center justify-between cursor-pointer hover:bg-brand-light text-xs font-normal hover:text-white">{{option.text}}
        <MozIcon class="ml-5 mr-2" iconName="check" />
        </div>
    </div>
  </div>
  </OnClickOutside>
</template>

<script>
import Popper from 'popper.js';
import MozIcon from './MozgoIcon.vue';
import OnClickOutside from '../../OnClickOutside.vue';

export default {
  components: {
    MozIcon,
    OnClickOutside,
  },
  props: {
    placeholder: {
      default: 'placeholder',
      type: String,
    },
    placement: {
      default: 'bottom',
      type: String,
    },
    selectOptions: {
      default: [],
    },
    number: {
      default: 0,
      type: Number,
    },
    selectedOption: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      selected: this.selectOptions[this.selectedOption].text,
      popIsOpen: false,
      popper: undefined,
    };
  },

  watch: {
    popIsOpen() {
      this.setupPopper();
    },
  },

  methods: {
    closePopper() {
      this.popIsOpen = false;
    },

    dropDownToggle() {
      this.popIsOpen = !this.popIsOpen;
    },

    setupPopper() {
      if (this.popper === undefined) {
        const selector = this.$refs.selector;
        const items = this.$refs.items;
        this.popper = new Popper(selector, items, {
          placement: 'bottom-end',
          eventsEnabled: false,
        });
      }
    },

    selectOption(idx) {
      // this.$emit('input', idx);
      this.selected = this.selectOptions[idx].text;
      // console.log('input', this.selectOptions[idx].sort_type, this.selectOptions[idx].sort_direction)
      this.$emit('input', this.selectOptions[idx].sort_type, this.selectOptions[idx].sort_direction, idx);
      this.closePopper();
    },
  },
  // @Watch('popIsOpen')
  // onPopIsOpenChanged() {
  //   this.setupPopper();
  // }


};
</script>

<style scoped>
.selector-handler {
  transition: all 0.2s ease;
  margin-top: 3px;
}
.selector-handler.deg {
  transform: rotate(180deg);
}
@media (max-width: 576px) {
.items {
  width: 95%;
  transform: translateX(-50px)
}
}
</style>
